























import { defineComponent, ref, useRouter } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "SearchBar",
  components: {},
  props: {
    isSearchOpen: {
      type: Boolean,
      default: false,
    },
    itemsPerPage: {
      type: Number,
      default: 12,
    },
    minTermLen: {
      type: Number,
      default: 3,
    },
  },
  emits: ["set-is-open", "set-search-results", "open-popup"],
  setup(props, { emit }) {
    const router = useRouter();

    const isOpenSearch = ref(false);
    const searchHeader = ref(null);
    const forcusInputSearch = ref(null);

    const gotoSearch = () => {
      isOpenSearch.value = false;
      if (searchHeader && searchHeader.value?.length > 0) {
        router.push(`/search?q=${searchHeader.value}`);
      }
    };
    
    const openSearch = () => {
      isOpenSearch.value = true;
      forcusInputSearch.value = setInterval(() => {
        document.getElementById("search-input-focus")?.focus();
      }, 1000);
    };
    
    const hideOpenSearch = () => {
      isOpenSearch.value = false;
      clearInterval(forcusInputSearch.value);
    };
    
    const toggleSearchPopup = () => {
      emit("open-popup");
      openSearch();
    };
    
    const hideMenu = () => {
      //   $emit('hide', false)
    };
    
    const deleteSearch = () => {
      searchHeader.value = null;
    };

    return {
      gotoSearch,
      openSearch,
      hideOpenSearch,
      hideMenu,
      deleteSearch,
      isOpenSearch,
      searchHeader,
      toggleSearchPopup,
    };
  },
});
